'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { unwrapMenuItems } from '../../helpers/unwrapMenuItems.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import '../../mixins/media.js';
import { keyboardFocusOutline } from '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import '../../mixins/textStyle.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { MenuProvider, useMenu } from './MenuProvider.js';

const StyledMenuContainer = styled.div.withConfig({
  componentId: "sc-uk5hsb-0"
})(["", ";padding:0;margin:0;flex:0 0 100%;flex-direction:column;align-items:flex-start;", " ", ""], defaultStyles.boxSizing, ({
  spaceAfter
}) => spaceProp(spaceAfter), keyboardFocusOutline({
  offset: -3
}));
const MenuContainer = /*#__PURE__*/withTitan(_a => {
  var {
      children,
      label,
      shouldHandleFocusOutside,
      spaceAfter,
      testId,
      role = 'menu'
    } = _a,
    rest = __rest(_a, ["children", "label", "shouldHandleFocusOutside", "spaceAfter", "testId", "role"]);
  const {
    containerRef,
    onKeyDown,
    onFocus,
    onBlur
  } = useMenu();
  return jsx(StyledMenuContainer, Object.assign({
    ref: containerRef,
    "aria-label": label,
    "data-test-id": testId,
    role: role,
    spaceAfter: spaceAfter,
    tabIndex: shouldHandleFocusOutside ? undefined : 0,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: !shouldHandleFocusOutside ? onKeyDown : undefined
  }, rest, {
    children: children
  }));
}, {
  name: 'MenuContainer'
});
const Menu = /*#__PURE__*/withTitan(_a => {
  var {
      children,
      label,
      shouldFocusFirstItem,
      shouldHandleFocusOutside,
      testId = 'menu',
      onSelect,
      onClose
    } = _a,
    rest = __rest(_a, ["children", "label", "shouldFocusFirstItem", "shouldHandleFocusOutside", "testId", "onSelect", "onClose"]);
  const items = unwrapMenuItems(children);
  return jsx(MenuProvider, {
    items: items,
    shouldFocusFirstItem: shouldFocusFirstItem,
    shouldHandleFocusOutside: shouldHandleFocusOutside,
    onClose: onClose,
    onSelect: onSelect,
    children: jsx(MenuContainer, Object.assign({
      "data-test-id": testId,
      label: label,
      shouldHandleFocusOutside: shouldHandleFocusOutside
    }, rest, {
      children: children
    }))
  });
}, {
  name: 'Menu'
});

export { Menu };
//# sourceMappingURL=Menu.js.map
